import { ConfigurationHttpClient } from '../../core/httpclient/configuration.httpclient';
import { Configuration, EMPTY_CONFIGURATION } from '../../core/models/apis';
import { shareReplay, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { AnyValue } from '@shared/types/any-value.type';

/** Service permettant de récupérer la configuration */
@Injectable({ providedIn: 'root' })
export class ConfigurationService {
  public configuration: Configuration = EMPTY_CONFIGURATION;
  private _configuration$: Observable<Configuration> = EMPTY;

  constructor(private readonly _configurationHttpClient: ConfigurationHttpClient) {}

  public get urlApiSiVision(): string {
    return this.configuration.urlApiSiVisionV1;
  }

  public get urlApiSiretManagement(): string {
    return this.configuration.urlApiSiretManagement;
  }

  public get urlApiMsOrder(): string {
    return this.configuration.urlApiMsOrder;
  }
  public get urlBusinessManagement(): string {
    return this.configuration.urlBusinessManagement;
  }
  public get urlApiCLoudManagement(): string {
    return this.configuration.urlApiCloudManagement;
  }

  public get authentication(): AnyValue {
    return this.configuration.authentication;
  }

  public get shineMigrationOlStartDate(): string | undefined {
    return this.configuration.shineMigrationOlStartDate;
  }

  public get shineMigrationOtherStartDate(): string | undefined {
    return this.configuration.shineMigrationOtherStartDate;
  }

  public get migrationFeatureEndDate(): Date | undefined {
    return this.configuration.migrationFeatureEndDate
      ? new Date(this.configuration.migrationFeatureEndDate)
      : undefined;
  }

  public get shineMigrationFactureEbpUrl(): string | undefined {
    return this.configuration.shineMigrationFactureEbpUrl;
  }

  public get expireDomainByHours(): number {
    return this.configuration.expireDomainByHours ?? 48;
  }

  private static get _configFile(): string {
    return `assets/configuration.json`;
  }

  /**
   * Retourne la configuration propre à l'environnement
   */
  public load(): Observable<Configuration> {
    if (this._configuration$ === EMPTY) {
      this._configuration$ = this._configurationHttpClient.get<Configuration>(ConfigurationService._configFile).pipe(
        shareReplay(1),
        tap((configuration: Configuration) => {
          this.configuration = { ...configuration };
        }),
      );
    }
    return this._configuration$;
  }
}
